import Link from 'next/link'

interface IProps {
	title: string
	text?: string
	textChildren?: React.ReactNode
	buttonText?: string
	buttonLink?: string
	buttonIconDesktop?: string
	buttonIconMobile?: string
}

export default function ZHeroCompactLeftCard({
	title,
	text,
	textChildren,
	buttonText,
	buttonLink,
	buttonIconDesktop = 's_ar2_rd',
	buttonIconMobile = 's_ar2_r'
}: IProps) {
	const hasLongTitle = title.split(/\s+/).some(word => word.length > 17) || title?.length > 40

	return (
		<div className='box_detail-amb_left overflow-hidden'>
			<div className='box_detail-amb_left_inner'>
				<h1 className={`title_h1${hasLongTitle ? ' title_h1_smaller' : ''}`}>{title}</h1>

				<div className='page_content reset_margins nobalance mgt-20lg mgt-30'>
					{text && <p>{text}</p>}
					{textChildren}
				</div>

				{buttonText && buttonLink && (
					<>
						<Link
							href={buttonLink}
							title={buttonText}
							className='btn_basic type7 hide_lgm'
							prefetch={false}
						>
							<span>{buttonText}</span>
							<span>
								<span>
									<svg className='sico'>
										<use
											href={`/assets/layout/icons.svg#${buttonIconDesktop}`}
										/>
									</svg>
								</span>
								<span>
									<svg className='sico'>
										<use
											href={`/assets/layout/icons.svg#${buttonIconMobile}`}
										/>
									</svg>
								</span>
							</span>
						</Link>
						<Link
							href={buttonLink}
							title={buttonText}
							className='btn_basic type2 mgt-40 mgt-30lg hide_lg'
							prefetch={false}
						>
							<span>{buttonText}</span>
							<span>
								<span>
									<svg className='sico'>
										<use
											href={`/assets/layout/icons.svg#${buttonIconDesktop}`}
										/>
									</svg>
								</span>
								<span>
									<svg className='sico'>
										<use
											href={`/assets/layout/icons.svg#${buttonIconMobile}`}
										/>
									</svg>
								</span>
							</span>
						</Link>
					</>
				)}
			</div>
		</div>
	)
}
